import _ from 'lodash';

export const showErrorMessage = (self, message) => {
  self.$notifications.notify({
    message: `<span>${message}</span>`,
    icon: 'fa fa-exclamation-triangle',
    horizontalAlign: 'center',
    verticalAlign: 'top',
    type: 'danger'
  });
};

export const getErrorMessageFromResponse = err => {
  const defaultMessage =
    'Ocorreu algum erro interno. Tente novamente mais tarde.';
  try {
    const responseMessage =
      _.get(err, 'response.status') === 400 &&
      _.get(err, 'response.data.message');
    if (responseMessage) {
      return responseMessage;
    }
    // eslint-disable-next-line no-empty
  } catch (e) {}
  return defaultMessage;
};
